import { useDispatch, useSelector } from 'react-redux';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { TEXT_COMMON } from 'constants/string/texts';
import AppRoutes from 'routes/routes';
import { clearModal, setModal } from 'store/actions/common';

const useChangeRouter = () => {
  const { history_create_survey } = useSelector((state) => state.survey);
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const location = useLocation();

  const onLeaveCreateSurvey = (to) => {
    const confirmDelete = () => {
      navigator(to);
      dispatch(clearModal());
    };

    dispatch(
      setModal({
        isOpen: true,
        type: 'delete',
        title: TEXT_COMMON.CONFIRM_LEAVE_PAGE_EDIT,
        confirmText: TEXT_COMMON.DELETE,
        cancelText: TEXT_COMMON.CANCEL_TEXT,
        onConfirm: confirmDelete,
        onCancel: () => {
          dispatch(clearModal());
        },
      })
    );
  };

  const goto = (to) => {
    const pathMatchCreateSurvey = matchPath(AppRoutes.surveyCreate, location.pathname);
    const pathMatchEditSurvey = matchPath(AppRoutes.surveyEdit, location.pathname);
    if ((pathMatchCreateSurvey || pathMatchEditSurvey) && history_create_survey && history_create_survey.length > 1) {
      onLeaveCreateSurvey(to);
    } else {
      navigator(to);
    }
  };

  return { goto };
};

export default useChangeRouter;
